<div class="main-popup mt-3">
    <div class="main-title-popup mb-4 text-center">
        <h1>User Details</h1>
    </div>
    <div class="row" *ngIf="userDetails">
        <div class="col-md-6 mb-3">
            <label>Username</label>
            <input
                type="text"
                class="form-control"
                [value]="userDetails.name || 'N/A'"
                disabled
                readonly
            />
        </div>
        <div class="col-md-6 mb-3">
            <label>Phone Number</label>
            <input
                type="text"
                class="form-control"
                [value]="userDetails.phone || 'N/A'"
                disabled
                readonly
            />
        </div>
        <div class="col-md-6 mb-3">
            <label>Employee ID</label>
            <input
                type="text"
                class="form-control"
                [value]="userDetails.employeeId || 'N/A'"
                disabled
                readonly
            />
        </div>
        <div class="col-md-6 mb-3">
            <label>Email ID</label>
            <input
                type="email"
                class="form-control"
                [value]="userDetails.email || 'N/A'"
                disabled
                readonly
            />
        </div>
        <div class="col-md-6 mb-3">
            <label>Country</label>
            <input
                type="text"
                class="form-control"
                [value]="userDetails.countryCode || 'N/A'"
                disabled
                readonly
            />
        </div>
        <div class="col-md-6 mb-3">
            <label>User Role</label>
            <input
                type="text"
                class="form-control"
                [value]="userDetails.roleName || 'N/A'"
                disabled
                readonly
            />
        </div>
    </div>
    <div *ngIf="!userDetails" class="text-center">
        <p>No user details available.</p>
        <div *ngIf="!userDetails" class="text-center">
            <p>No user details available.</p>
        </div>
        <div class="text-center mt-4">
            <button
                class="btn btn-action-primary"
                type="button"
                (click)="onClose()"
            >
                Close
            </button>
        </div>
    </div>
</div>
